import { useEffect } from 'react';

function useConstructor(func: Function) {
  useEffect(() => {
    func();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useConstructor;
